module.exports = __webpack_public_path__ + "media/images/japan/icon_chevron-561696e8b4d6ecdecce67240625ff187.svg";